import classNames from 'classnames';

import { DefaultLink } from 'hb-react/frontoffice/components/Link';

function content_link(link_type, title) {
  const available_icons = [
    'twitter',
    'facebook',
    'linkedin',
    'xing',
    'youtube',
    'instagram',
    'googleplus',
  ];

  if (available_icons.indexOf(link_type) > -1) {
    if (link_type == 'googleplus') link_type = 'google-plus';

    return <i className={`icon-${link_type}`} />;
  }

  return title;
}

const Link = ({ link_type, title, url }) => (
  <DefaultLink
    href={url}
    target="_blank"
    className={classNames('soft-half--left', {
      'soft-quarter--bottom': link_type != 'social_links',
    })}
  >
    {content_link(link_type, title)}
  </DefaultLink>
);

export default Link;
